export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      program: "Programa",
      activities: "Actividades",
      pricing: "Inscripciones",
      gallery: "Galería",
      contact: "Contacto",
      cta: "Pre-inscripción",
      summer: "🌞 Verano",
    },
    hero: {
      overline: "Ciclo Escolar 2026 – 2027",
      title1: "Caminando",
      title2: "Juntos",
      subtitle:
        "Un espacio educativo bilingüe donde las niñas y niños descubren, crean y crecen — a través del aprendizaje activo y el juego consciente.",
      ctaPrimary: "Agenda una visita",
      ctaSecondary: "Conoce el programa",
      stat1: "Maternal a Pre-First",
      stat2: "90% en Inglés en grados superiores",
      stat3: "Música · Robótica · Natación",
    },
    about: {
      overline: "Nuestra Filosofía",
      title: "Un ser bio-psico-social en pleno desarrollo.",
      body: "El propósito de STEPS es lograr un espacio educativo donde se propicie el desarrollo de todas las potencialidades del niño preescolar — no sólo a corto, sino a largo plazo — para formar personas íntegras, críticas, creativas y con iniciativa, capaces de integrarse a la sociedad y de transformarla.",
      pillars: [
        { title: "Aprendizaje Activo", desc: "Los niños no son consumidores pasivos: el conocimiento nace de su acción sobre los objetos y su entorno." },
        { title: "Ambiente de Apoyo", desc: "Docentes cálidas y una rutina clara que fomentan iniciativa, lenguaje y descubrimiento." },
        { title: "Desarrollo Integral", desc: "Evaluación basada en el desarrollo real, respetando cada estadío y ritmo individual." },
      ],
    },
    program: {
      overline: "Programa Pedagógico",
      title: "Un método natural, bilingüe y totalmente integrado.",
      body: "Siendo un colegio bilingüe, implementamos el método natural de aprendizaje: rimas, canciones, indicaciones y rutinas en inglés acompañan toda la mañana. En los últimos tres grados, la rutina se maneja en un 90% en inglés.",
      areas: [
        { title: "Lectoescritura", desc: "Descubrimiento de la lengua escrita a través de la acción y el juego." },
        { title: "Lógico-matemático", desc: "Nociones numéricas y de razonamiento adaptadas al desarrollo." },
        { title: "Motricidad", desc: "Habilidades perceptuales, motricidad fina y gruesa." },
        { title: "Inglés Inmersivo", desc: "Método natural: 90% en inglés en los grados superiores." },
      ],
    },
    activities: {
      overline: "Actividades Extracurriculares",
      title: "Conocimientos ligados a la acción.",
      items: [
        { name: "Música", emoji: "music", description: "Exploran ritmo, melodías e instrumentos. Cantamos en español e inglés para desarrollar memoria, coordinación y sensibilidad auditiva desde muy temprana edad." },
        { name: "Danza", emoji: "dance", description: "Movimiento corporal con música. Las niñas y niños desarrollan coordinación, expresión corporal y el gusto por el trabajo en equipo a través del baile." },
        { name: "Teatro", emoji: "theatre", description: "Expresión dramática con obras cortas, títeres y juegos de rol. Fortalece el lenguaje, la seguridad personal y la creatividad." },
        { name: "Biblioteca", emoji: "book", description: "Hora del cuento y acercamiento al amor por la lectura. Descubren la lengua escrita en español e inglés a través de historias ilustradas." },
        { name: "Computación", emoji: "computer", description: "Introducción al uso de la tecnología con juegos educativos. Pensamiento lógico y familiarización con herramientas digitales." },
        { name: "Robótica", emoji: "robot", description: "Construcción y programación básica con robots adaptados a su edad. Desarrollan pensamiento secuencial y resolución de problemas." },
        { name: "Cuántica", emoji: "atom", description: "Introducción divertida a conceptos científicos y de pensamiento crítico. Exploración, preguntas y descubrimiento del mundo que nos rodea." },
        { name: "Educación Física", emoji: "sport", description: "Actividad física diaria con ejercicios adaptados a cada edad. Fomenta motricidad, salud y valores como el trabajo en equipo." },
        { name: "Natación", emoji: "swim", description: "Clases de natación para Kinder 2, 3 y Pre-First. Seguridad acuática, coordinación y confianza en el agua." },
      ],
    },
    pricing: {
      overline: "Ciclo Escolar 2026 – 2027",
      title: "Horarios e inscripción",
      subtitle:
        "Estos son nuestros horarios de atención. Para conocer costos de inscripción y colegiaturas, te invitamos a agendar una cita de información donde con gusto te los compartimos.",
      schedule: "Horario Regular",
      extendedTitle: "Horario Extendido",
      extendedTime: "8:00 AM – 3:30 PM",
      extendedNote: "Disponible bajo solicitud para familias que lo requieran.",
      costsTitle: "¿Quieres conocer los costos?",
      costsDesc:
        "En tu cita de información te compartiremos con todo detalle la inscripción, material, seguro escolar y las colegiaturas mensuales del ciclo.",
      schedules: [
        { grade: "Maternales", time: "9:00 AM – 12:30 PM" },
        { grade: "Kinder 1", time: "8:45 AM – 1:00 PM" },
        { grade: "Kinder 2", time: "8:30 AM – 1:15 PM" },
        { grade: "Kinder 3", time: "8:15 AM – 1:30 PM" },
        { grade: "Pre-First", time: "8:05 AM – 1:45 PM" },
      ],
      notes: [
        "La cuota de inscripción NO incluye libros — contacta a oficina para detalles.",
        "Iniciado el ciclo escolar, no se reembolsará ningún pago realizado.",
        "Cuota de natación para Kinder 2, 3 y Pre-First: se informará en cuanto el prestador del servicio nos notifique.",
        "Las colegiaturas se pagan dentro de los primeros 10 días de cada mes (Sep–Jul, 11 meses).",
      ],
      cta: "Agenda tu cita informativa",
    },
    gallery: {
      overline: "Nuestros Momentos",
      title: "Caminando juntos, todos los días.",
    },
    contact: {
      overline: "Pre-inscripción",
      title: "Agenda tu visita a STEPS",
      subtitle:
        "Déjanos tus datos y te contactamos para una visita guiada. También puedes llamarnos o escribirnos directo por WhatsApp.",
      quickContactLabel: "Respuesta inmediata",
      quickContactText: "Llámanos al",
      form: {
        parentName: "Nombre del padre/madre/tutor",
        childName: "Nombre del niño/a",
        childAge: "Edad del niño/a",
        grade: "Grado de interés",
        email: "Correo electrónico",
        phone: "Teléfono",
        message: "Mensaje (opcional)",
        submit: "Enviar solicitud",
        sending: "Enviando...",
        success: "¡Gracias! Recibimos tu solicitud y te contactaremos muy pronto.",
        error: "No se pudo enviar la solicitud. Intenta de nuevo o llámanos.",
        selectGrade: "Selecciona un grado",
      },
      info: {
        phoneLabel: "Teléfono",
        phone: "442.234.21.14",
        whatsappLabel: "WhatsApp",
        whatsapp: "442.118.28.16",
        emailLabel: "Correo",
        email: "kinder_steps@yahoo.com.mx",
        socialLabel: "Síguenos:",
      },
    },
    footer: {
      tagline: "Caminando juntos, por la educación de sus hijos.",
      rights: "Todos los derechos reservados.",
    },
    summer: {
      bannerBrand: "STEPS · ADMISIONES",
      bannerHighlight: "Últimos lugares disponibles",
      bannerSub: "Inscripciones abiertas · Ciclo 2026–2027",
      bannerCta: "Más info",
      overline: "Próxima edición · Verano 2027",
      concludedBadge: "Edición 2026 concluida",
      subtitle: "La edición 2026 fue todo un éxito. Déjanos tus datos y te avisamos en cuanto abramos inscripciones para el verano 2027.",
      info: {
        dates: { label: "Fechas", value: "Verano 2027" },
        hours: { label: "Horario", value: "9:00 – 13:30 hrs" },
        ages: { label: "Edades", value: "2 a 7 años" },
        location: { label: "Ubicación", value: "Juriquilla, Qro." },
      },
      activitiesLabel: "Actividades diarias",
      activities: ["Deportes", "Psicomotricidad", "Arte", "Manualidades", "Cocina", "Teatro", "Música", "Ecología", "Ludoteca"],
      ctaWhatsapp: "Quiero información por WhatsApp",
      ctaForm: "Déjanos tus datos",
      urgency: "🎉 Nos vemos en el verano 2027",
      year: "2027",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      program: "Program",
      activities: "Activities",
      pricing: "Tuition",
      gallery: "Gallery",
      contact: "Contact",
      cta: "Pre-enrollment",
      summer: "🌞 Summer",
    },
    hero: {
      overline: "School Year 2026 – 2027",
      title1: "Walking",
      title2: "Together",
      subtitle:
        "A bilingual learning space where children discover, create and grow — through active learning and mindful play.",
      ctaPrimary: "Schedule a visit",
      ctaSecondary: "Explore the program",
      stat1: "Maternal to Pre-First",
      stat2: "90% English in upper grades",
      stat3: "Music · Robotics · Swimming",
    },
    about: {
      overline: "Our Philosophy",
      title: "A bio-psycho-social being in full development.",
      body: "STEPS' purpose is to provide an educational space that fosters every potential of the preschool child — short and long term — shaping whole, critical, creative and proactive individuals capable of integrating into and transforming society.",
      pillars: [
        { title: "Active Learning", desc: "Children are not passive consumers: knowledge is born from their action on objects and environment." },
        { title: "Supportive Climate", desc: "Warm teachers and a clear routine that foster initiative, language and discovery." },
        { title: "Integral Development", desc: "Assessment based on real development — respecting each stage and individual rhythm." },
      ],
    },
    program: {
      overline: "Pedagogical Program",
      title: "A natural, bilingual, fully integrated method.",
      body: "As a bilingual school, we implement the natural language-learning method: rhymes, songs and routine indications in English throughout the morning. In the last three grades, the routine is 90% in English.",
      areas: [
        { title: "Literacy", desc: "Discovering written language through action and play." },
        { title: "Logic & Math", desc: "Number and reasoning notions tailored to each developmental stage." },
        { title: "Motor Skills", desc: "Perceptual skills, fine and gross motor development." },
        { title: "Immersive English", desc: "Natural method: 90% English in upper grades." },
      ],
    },
    activities: {
      overline: "Extracurricular Activities",
      title: "Knowledge tied to action.",
      items: [
        { name: "Music", emoji: "music", description: "Children explore rhythm, melody and instruments. We sing in Spanish and English to develop memory, coordination and auditory sensitivity from the earliest age." },
        { name: "Dance", emoji: "dance", description: "Body movement with music. Kids develop coordination, self-expression and the joy of teamwork through choreography." },
        { name: "Theatre", emoji: "theatre", description: "Dramatic expression through short plays, puppets and role-playing games. Strengthens language, confidence and creativity." },
        { name: "Library", emoji: "book", description: "Story hour and love for reading. Children discover written language in Spanish and English through illustrated stories." },
        { name: "Computing", emoji: "computer", description: "Introduction to technology with age-appropriate educational games. Develops logical thinking and digital literacy." },
        { name: "Robotics", emoji: "robot", description: "Hands-on construction and basic programming with child-friendly robots. Sequential thinking and problem solving." },
        { name: "Quantum", emoji: "atom", description: "A playful introduction to scientific concepts and critical thinking. Exploration, questions and discovery of the world around us." },
        { name: "Physical Ed.", emoji: "sport", description: "Daily physical activity tailored to each age — motor skills, health and teamwork values." },
        { name: "Swimming", emoji: "swim", description: "Swim lessons for Kinder 2, 3 and Pre-First. Water safety, coordination and confidence in the pool." },
      ],
    },
    pricing: {
      overline: "School Year 2026 – 2027",
      title: "Schedules & Enrollment",
      subtitle:
        "These are our regular hours. For enrollment and tuition details, we'd love to meet you — schedule an info visit and we'll walk you through everything.",
      schedule: "Regular Schedule",
      extendedTitle: "Extended Schedule",
      extendedTime: "8:00 AM – 3:30 PM",
      extendedNote: "Available upon request for families who need it.",
      costsTitle: "Want to know the fees?",
      costsDesc:
        "At your info visit we'll share in detail the enrollment fee, materials, school insurance and monthly tuition for the school year.",
      schedules: [
        { grade: "Maternales", time: "9:00 AM – 12:30 PM" },
        { grade: "Kinder 1", time: "8:45 AM – 1:00 PM" },
        { grade: "Kinder 2", time: "8:30 AM – 1:15 PM" },
        { grade: "Kinder 3", time: "8:15 AM – 1:30 PM" },
        { grade: "Pre-First", time: "8:05 AM – 1:45 PM" },
      ],
      notes: [
        "Enrollment fee does NOT include books — contact the office for details.",
        "Once the school year starts, no payments will be refunded.",
        "Swimming fee for Kinder 2, 3 and Pre-First will be announced by the service provider.",
        "Monthly tuition is paid within the first 10 days of each month (Sep–Jul, 11 months).",
      ],
      cta: "Schedule your info visit",
    },
    gallery: {
      overline: "Our Moments",
      title: "Walking together, every single day.",
    },
    contact: {
      overline: "Pre-enrollment",
      title: "Schedule your STEPS visit",
      subtitle:
        "Leave your details and we'll contact you for a guided visit. You can also call or WhatsApp us directly.",
      quickContactLabel: "Instant reply",
      quickContactText: "Call us at",
      form: {
        parentName: "Parent/guardian name",
        childName: "Child's name",
        childAge: "Child's age",
        grade: "Grade of interest",
        email: "Email",
        phone: "Phone",
        message: "Message (optional)",
        submit: "Send request",
        sending: "Sending...",
        success: "Thank you! We received your request and we'll contact you very soon.",
        error: "Couldn't submit the request. Try again or call us.",
        selectGrade: "Select a grade",
      },
      info: {
        phoneLabel: "Phone",
        phone: "442.234.21.14",
        whatsappLabel: "WhatsApp",
        whatsapp: "442.118.28.16",
        emailLabel: "Email",
        email: "kinder_steps@yahoo.com.mx",
        socialLabel: "Follow us:",
      },
    },
    footer: {
      tagline: "Walking together, for the education of your children.",
      rights: "All rights reserved.",
    },
    summer: {
      bannerBrand: "STEPS · ADMISSIONS",
      bannerHighlight: "Last spots available",
      bannerSub: "Enrollment open · School year 2026–2027",
      bannerCta: "Learn more",
      overline: "Next edition · Summer 2027",
      concludedBadge: "2026 edition concluded",
      subtitle: "Our Summer 2026 was a huge success. Leave your info and we'll notify you the moment enrollment opens for Summer 2027.",
      info: {
        dates: { label: "Dates", value: "Summer 2027" },
        hours: { label: "Hours", value: "9:00 AM – 1:30 PM" },
        ages: { label: "Ages", value: "2 to 7 years" },
        location: { label: "Location", value: "Juriquilla, Qro." },
      },
      activitiesLabel: "Daily activities",
      activities: ["Sports", "Psychomotor", "Art", "Crafts", "Cooking", "Theatre", "Music", "Ecology", "Playroom"],
      ctaWhatsapp: "Get info via WhatsApp",
      ctaForm: "Leave your info",
      urgency: "🎉 See you in summer 2027",
      year: "2027",
    },
  },
};

export const GRADES = [
  "Maternal 1",
  "Maternal 2",
  "Kinder 1",
  "Kinder 2",
  "Kinder 3",
  "Pre-First",
];
